// extracted by mini-css-extract-plugin
export var notificationHost = "_kp-0";